// Generated by purs version 0.15.15
import * as Affjax from "../Affjax/index.js";
import * as Affjax_RequestBody from "../Affjax.RequestBody/index.js";
import * as Affjax_RequestHeader from "../Affjax.RequestHeader/index.js";
import * as Affjax_ResponseFormat from "../Affjax.ResponseFormat/index.js";
import * as Affjax_StatusCode from "../Affjax.StatusCode/index.js";
import * as Affjax_Web from "../Affjax.Web/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Codec_Argonaut from "../Data.Codec.Argonaut/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
import * as Fusion_Util from "../Fusion.Util/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as URI_Path_Segment from "../URI.Path.Segment/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var bindExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Effect_Aff.monadAff);
var bind = /* #__PURE__ */ Control_Bind.bind(bindExceptT);
var monadErrorExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.monadErrorExceptT(Effect_Aff.monadAff);
var liftAffErr = /* #__PURE__ */ Fusion_Util.liftAffErr(monadErrorExceptT)(/* #__PURE__ */ Effect_Aff_Class.monadAffExceptT(Effect_Aff_Class.monadAffAff));
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(bindExceptT);
var applicativeExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Effect_Aff.monadAff);
var unless = /* #__PURE__ */ Control_Applicative.unless(applicativeExceptT);
var eq = /* #__PURE__ */ Data_Eq.eq(Affjax_StatusCode.eqStatusCode);
var throwError = /* #__PURE__ */ Control_Monad_Error_Class.throwError(/* #__PURE__ */ Control_Monad_Except_Trans.monadThrowExceptT(Effect_Aff.monadAff));
var show = /* #__PURE__ */ Data_Show.show(Affjax_StatusCode.showStatusCode);
var liftEitherErr = /* #__PURE__ */ Fusion_Util.liftEitherErr(monadErrorExceptT);
var pure = /* #__PURE__ */ Control_Applicative.pure(applicativeExceptT);
var mkClient = function (opts) {
    var queryEncoded = Data_Maybe.fromMaybe([  ])(map(opts.encodeQuery)(opts.query));
    var mayBodyEncoded = map(function ($25) {
        return Affjax_RequestBody.json(opts.encodeBody($25));
    })(opts.body);
    var headers = [ map(function (tok) {
        return new Affjax_RequestHeader.RequestHeader("Authorization", "Bearer " + tok);
    })(opts.token) ];
    var fullUrl = (function (url) {
        return Data_Array.foldr(function (v) {
            return MST_Data_BasicURL.addQueryParameter(v.value0)(v.value1);
        })(url)(queryEncoded);
    })((function (url) {
        return Data_Array.foldr(function ($26) {
            return MST_Data_BasicURL.addPathSegment(URI_Path_Segment.segmentFromString($26));
        })(url)(opts.path);
    })(opts.baseUrl));
    var fullUrlStr = MST_Data_BasicURL.print(fullUrl);
    var req = {
        username: Affjax.defaultRequest.username,
        password: Affjax.defaultRequest.password,
        withCredentials: Affjax.defaultRequest.withCredentials,
        timeout: Affjax.defaultRequest.timeout,
        responseFormat: Affjax_ResponseFormat.json,
        method: new Data_Either.Left(opts.method),
        url: fullUrlStr,
        content: mayBodyEncoded,
        headers: Data_Array.catMaybes(headers)
    };
    return Control_Monad_Except_Trans.runExceptT(bind(liftAffErr(function ($27) {
        return opts.mkCnError(Affjax.printError($27));
    })(Affjax_Web.request(req)))(function (result) {
        return discard(unless(eq(result.status)(200))(throwError(opts.mkReError("Request failed with status: " + show(result.status)))))(function () {
            return bind(liftEitherErr(function ($28) {
                return opts.mkReError(Data_Codec_Argonaut.printJsonDecodeError($28));
            })(opts.decodeResponse(result.body)))(function (val) {
                return pure(val);
            });
        });
    }));
};
export {
    mkClient
};
